<main class="h-screen w-screen overflow-auto">
    <router-outlet></router-outlet>
</main>